module.exports = __webpack_public_path__ + "img/wz-7-2-3.37657a78.jpg";